export const typography = {
  fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
};
